<template lang="pug">
  CommonSection(title="Учетная запись")
    .b-user-account(v-if="user")
      ._aside
        ._name {{ user.name }} {{ user.surname }}
        AvatarEditable._avatar(:avatar="user.avatar" @change="onAvatarChanged")
        ._actions
          router-link(:to="{ name: 'notification-settings' }")
            Icon(name="settings" pointer)
          router-link(:to="{ name: 'notifications' }")
            Icon(name="bell" pointer)
        ._support Поддержка
          a(href="mailto:support@teroom.ru")  support@teroom.ru
      FormBlock._main
        template(v-if="$route.params.category")
          h2._title {{ selectedCategory.label }}
            ._underline
          router-view(:user="user")
        div._container(v-else)
          section(v-for="category in categorizedParams")
            h2._title {{ category.label }}
            ._underline
              Btn(grey narrow v-if="category.editable" @click="openForm(category.name)")._edit-btn Редактировать
            .b-user-data._params
              ._row(v-for="param in category.params" :key="param.name + param.label")
                ._name {{ param.label }}
                ._value {{ param.value }}
                ._icon
                  Icon(:name="param.icon" v-if="param.icon")
                ._hint(v-if="param.hint") {{ param.hint }}
</template>

<script>
import timezones from '@/utils/timezones';
import utils from '@/utils/common';

import CommonSection from '@/components/CommonSection.vue';
import FormBlock from '@/components/FormBlock.vue';
import BaseField from '@/components/BaseField.vue';
import AvatarEditable from '@/components/AvatarEditable.vue';
import userApi from '@/api/user';

export default {
  name: 'AccountDetail',
  components: { FormBlock, CommonSection, BaseField, AvatarEditable }, // eslint-disable-line
  data() {
    return {
      categories: [
        { name: 'main',     label: 'Основное',              editable: true  }, // eslint-disable-line
        { name: 'contacts', label: 'Контакты',              editable: true  }, // eslint-disable-line
        { name: 'settings', label: 'Настройки',             editable: true  }, // eslint-disable-line
        { name: 'security', label: 'Доступ и безопасность', editable: true  }, // eslint-disable-line
      ],
      params: {
        main: [
          { name: 'name',         label: 'Имя'              }, // eslint-disable-line
          { name: 'surname',      label: 'Фамилия'          }, // eslint-disable-line
          { name: 'createdAtStr', label: 'Зарегистрирован'  }, // eslint-disable-line
          { name: 'email',        label: 'Логин'            }, // eslint-disable-line
        ],
        contacts: [
          { name: 'notificationsEmail',   label: 'E-mail',    icon: 'mail',   hint: 'На этот адрес приходят важные уведомления, ответы тех. поддержки и платежные документы'  }, // eslint-disable-line
          { name: 'phone',                label: 'Телефон',   icon: 'phone',  hint: 'Необходим для подтверждения платёжных операций через СМС'                                }, // eslint-disable-line
          { name: 'skype',                label: 'Skype',     icon: 'skype'     }, // eslint-disable-line
          { name: 'telegram',             label: 'Telegram',  icon: 'telegram'  }, // eslint-disable-line
          { name: 'whatsapp',             label: 'WhatsApp',  icon: 'whatsapp'  }, // eslint-disable-line
        ],
        settings: [
          { name: 'country',      label: 'Страна'           }, // eslint-disable-line
          { name: 'city',         label: 'Город'            }, // eslint-disable-line
          { name: 'timezoneStr',  label: 'Часовой пояс'     }, // eslint-disable-line
          { name: 'dateBirthStr', label: 'Дата рождения'    }, // eslint-disable-line
          { name: 'genderName',   label: 'Пол'              }, // eslint-disable-line
        ],
        security: [
          { name: 'passwordUpdatedAtStr', label: 'Пароль изменен' }, // eslint-disable-line
        ],
      },
    };
  },
  computed: {
    user() {
      const { user } = this.$store.state.auth;

      if (!user) {
        return null;
      }

      const role = this.accountType(user?.roles ?? []);

      let genderName = '';
      let gender = '';
      switch (user?.gender) {
        case true: genderName = 'Мужской'; gender = 'male'; break;
        case false: genderName = 'Женский'; gender = 'female'; break;
        default: break;
      }

      const timezoneStr = timezones[(new Date()).getTimezoneOffset()] ?? '';

      const result = { ...user, role, gender, genderName, timezoneStr }; // eslint-disable-line

      const dates = [
        { field: 'createdAt',         withTime: true  }, // eslint-disable-line
        { field: 'passwordUpdatedAt', withTime: true  }, // eslint-disable-line
        { field: 'dateBirth',         withTime: false }, // eslint-disable-line
      ];

      dates.forEach((item) => {
        const date = user[item.field];

        if (date) {
          result[`${item.field}Str`] = utils.convertDateToString(new Date(user[item.field]), 'long', item.withTime);
        }
      });

      return result;
    },
    categorizedParams() {
      return this.categories.map((category) => {
        const params = this.params[category.name].map((param) => {
          const value = this.user?.[param.name];
          return { ...param, value };
        });
        return { ...category, params };
      });
    },
    selectedCategory() {
      return this.categories.find((item) => item.name === this.$route.params.category);
    },
  },
  methods: {
    accountType(roles) {
      switch (true) {
        case roles.includes('ROLE_DESIGNER'):   return 'Дизайнер';   // eslint-disable-line
        case roles.includes('ROLE_CUSTOMER'):   return 'Заказчик';   // eslint-disable-line
        default: return '';
      }
    },
    openForm(category) {
      this.$router.push({ name: 'account-edit', params: { category } });
    },
    async onAvatarChanged(avatar) {
      await userApi.update(this.user.id, { avatar: avatar?.['@id'] ?? null }, true);
      this.$store.commit('auth/setUser', { ...this.user, avatar });
    },
  },
};
</script>

<style scoped lang="scss">
.user-account {
  display: grid;
  grid-template-columns: 1fr 370px;
  align-items: start;

  &__aside {
    grid-column: 2;
    padding: 32px;
    margin-top: 34px;
    background: #fff;
    border-radius: 0 8px 8px 0;
    box-sizing: border-box;
    display: grid;
    grid-template-columns: 1fr;
    justify-items: center;
    gap: 18px;
  }

  &__avatar {
    display: block;
  }

  &__main {
    grid-column: 1;
    grid-row: 1;
  }

  &__title {
    font-size: 18px;
    line-height: 24px;
    color: var(--color-super-dark);
    margin-bottom: 8px;
  }

  &__underline {
    display: flex;
    align-items: center;
    gap: 25px;
    height: 38px;
    margin-bottom: 25px;

    &:before {
      content: '';
      display: block;
      height: 1px;
      flex-grow: 1;
      background: #D1D9F0;
    }
  }

  &__params {
    margin-bottom: 40px;
    padding-left: 25px;
  }

  &__name {
    font-size: 18px;
    line-height: 24px;
  }

  &__actions {
    display: flex;
    align-items: center;
    gap: 20px;
    margin-bottom: 5px;

    svg::v-deep path {
      transition: stroke .3s;
    }
    svg:hover::v-deep path {
      stroke: var(--color-hover);
    }
  }

  &__support {
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.01em;
    color: var(--color-middle-gray);

    a:hover {
      color: var(--color-hover);
    }
  }

  @media (max-width: 1600px) {
    grid-template-columns: 1fr 300px;
  }

  @media (max-width: 1000px) {
    grid-template-columns: 1fr;

    &__main {
      grid-row: 2;
      box-shadow: 6px 4px 17px 15px rgba(164, 164, 164, 0.08);
    }

    &__aside {
      grid-column: 1;
      padding-bottom: 42px;
      margin-bottom: -10px;
    }
  }

  @media (max-width: 1000px) and (min-width:576px) {
    &__aside {
      grid-template-columns: 1fr 1fr;
    }

    &__name {
      align-self: center;
      justify-self: start;
    }

    &__avatar {
      width: 153px !important;
      height: 153px !important;
    }

    &__actions {
      grid-column: 2;
      margin-bottom: 0;
    }

    &__support-btn {
      grid-row: 2;
      width: 100%;
    }
  }

  @media (max-width: 576px) {
    &__params {
      padding-left: 0;
    }
  }
}

.user-data {
  display: grid;
  gap: 35px;
  align-items: center;

  &__row {
    display: grid;
    grid-template-columns: 2fr 7fr 1fr;
  }

  &__name {
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.01em;
    color: var(--color-middle-gray);
  }

  &__hint {
    grid-column: 2;
    margin-top: 6px;
    font-size: 12px;
    line-height: 130%;
    letter-spacing: 0.01em;
    max-width: 333px;
    color: var(--color-middle-gray);
  }
  &__icon {
    justify-self: end;

    svg {
      fill: var(--color-middle-gray);
    }
  }

  @media (max-width: 1700px) {
    &__row {
      grid-template-columns: 2fr 5fr 1fr;
    }
  }

  @media (max-width: 1600px) {
    &__row {
      grid-template-columns: 2fr 4fr 1fr;
    }
  }

  @media (max-width: 1300px) {
    &__row {
      grid-template-columns: 2fr 3fr 1fr;
    }
  }

  @media (max-width:576px) {
    &__row {
      display: grid;
      grid-template-columns: 1fr 1fr 24px;
      gap: 10px;
    }
  }

  @media (max-width: 400px) {
    &__name {
      font-size: 12px;
      line-height: 18px;
      letter-spacing: -0.03em;
    }
  }
}
</style>
